import React, { useMemo } from "react";
import objectPath from "object-path";
import { NavLink, useHistory, Redirect } from "react-router-dom";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { QuickSearch } from "./extras/offcanvas/QuickSearch";
import { QuickNotification } from "./extras/offcanvas/QuickNotification";
import { QuickActions } from "./extras/offcanvas/QuickActions";
import { ScrollTop } from "./extras/ScrollTop";
import { StickyToolbar } from "./extras/StickyToolbar";
import { AnimateLoading } from "../../_partials/controls";

export function Layout({ children }) {
  // console.log("children", children);
  const history = useHistory();
  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  const logoutClick = () => {
    // const toggle = document.getElementById("kt_quick_user_toggle");
    // console.log("toggle", toggle);
    // if (toggle) {
    // 	toggle.click();
    // }
    // console.log("111111");
    // history.push("/logout");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userNo");
    localStorage.removeItem("userId");
    localStorage.removeItem("userRole");
    localStorage.removeItem("expirationDate");

    localStorage.removeItem("botAdminId");
    localStorage.removeItem("botAdminNo");

    window.location.href = "/";
  };
  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />

      <div className="d-flex flex-column flex-root">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          <Aside />

          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            {/*begin::Content*/}
            <div
              id="kt_content"
              style={{
                backgroundColor: "#F4F6F9",
                // backgroundImage:
                // 	"linear-gradient(127deg, #ff6f5e, #ffa45e 51%, #ff5edb 99%)",
              }}
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              <div>
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={logoutClick}
                >
                  로그아웃
                </button>
              </div>
              <AnimateLoading />
              {/* {layoutProps.subheaderDisplay && <SubHeader />} */}

              {/*begin::Entry*/}
              {layoutProps.contentExtended && <>{children}</>}

              {!layoutProps.contentExtended && (
                <div
                  className="d-flex flex-column-fluid"
                  style={{ marginLeft: "130px" }}
                >
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>
                    <div style={{ textAlign: "right" }}>
                      <button
                        className="btn btn-danger"
                        type="button"
                        onClick={logoutClick}
                      >
                        로그아웃
                      </button>
                    </div>
                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            <Footer />
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      {/* <QuickUser /> */}
      {/* <QuickPanel />
			<QuickNotification />
			<ScrollTop />
			<QuickSearch />
			<QuickActions />
			<StickyToolbar /> */}
      {/*end::Main*/}
      {/* <LayoutInit /> */}
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
